import { createService } from '@/services/service'

const apiUrl = '/api/v1'
const resource = 'patient/request'

const { fetchAll } = createService({ resource, apiUrl })

const update = (payload) => {
  return $axios.put(`${apiUrl}/${resource}`, payload)
}

const done = () => {
  return $axios.post(`${apiUrl}/${resource}/done`)
}

export default {
  fetchAll,
  update,
  done,
}
